<template>
  <div class="edit-audio-wrapper">
    <div class="edit-title">
      <el-button class="handlian-btn" @click="switchEdit">{{
        switchBtnText
      }}</el-button>
    </div>
    <div class="edit-body" v-show="showEditArea" v-loading="loadAudio">
      <el-form
        :model="editAudioForm"
        :rules="rules"
        :disabled="forbitEdit"
        ref="editAudioForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item prop="audioTitle">
          <el-input
            v-model="editAudioForm.audioTitle"
            placeholder="输入音频名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="audioContent">
          <el-input
            type="textarea"
            v-model="editAudioForm.audioContent"
            resize="none"
            :autosize="{ minRows: 2 }"
            maxlength="300"
            show-word-limit
            placeholder="输入音频介绍"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            class="upload-demo"
            ref="upload"
            :limit="1"
            :multiple="false"
            accept="audio/*"
            action="api/image/upload"
            :disabled="forbitUpload"
            :on-change="fileListChange"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-exceed="exceedLimit"
            :auto-upload="false"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              :disabled="forbitUpload"
              >选取音频</el-button
            >
            <div slot="tip" class="el-upload__tip">{{ uploaderTipText }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div class="edit-bar">
            <el-button
              class="handlian-btn"
              :disabled="forbitSave"
              type="primary"
              @click="submitForm('editAudioForm')"
              >{{ saveBtnText }}</el-button
            >
            <el-button
              class="handlian-btn"
              :disabled="resetForbit"
              @click="resetForm('editAudioForm')"
              >重置</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="share-video-wrap">
      <el-dialog
        title="提示"
        :visible.sync="shareVisible"
        width="30%"
        custom-class="handlian-share-article"
        :before-close="clearShareForm"
      >
        <span class="share-tip"
          >上传成功，您还可以分享新音频，不分享就点“取消”。</span
        >
        <el-form
          :model="shareAudioForm"
          :rules="shareRules"
          ref="shareAudioForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="分享区域" prop="shareArea">
            <el-checkbox-group v-model="shareAudioForm.shareArea">
              <el-checkbox label="shareFriends" name="shareArea"
                >小区</el-checkbox
              >
              <el-checkbox label="sharePublic" name="shareArea"
                >社区</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="handlian-btn" @click="clearShareForm"
            >取 消</el-button
          >
          <el-button
            class="handlian-btn"
            type="primary"
            @click="submitShareForm('shareAudioForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../utils/apiMap";
import { newFileName, htmlFilter } from "../../utils/feed";
import { mapGetters } from "vuex";
export default {
  name: "edit-audio",
  data() {
    return {
      showEditArea: false,
      switchBtnText: "上传音频",
      saveBtnText: "开始上传",
      reEditing: false,
      resetForbit: false,
      previewVisible: false,
      shareVisible: false,
      loadAudio: false,
      onInitImage: true,
      newAudioID: "",
      oldAudioID: "",
      editAudioForm: {
        audioTitle: "",
        audioSinger: "",
        audioContent: "",
      },
      uploaderTipText: "允许上传 1 个音频文件",
      shareAudioForm: {
        shareArea: [],
      },
      rules: {
        audioTitle: [
          { required: true, message: "请输入音频名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        audioContent: [
          { required: false, message: "请输入音频介绍", trigger: "blur" },
        ],
      },
      shareRules: {
        shareArea: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个分享区域",
            trigger: "change",
          },
        ],
      },
      fileList: [],
      awaitFile: [],
      fileCount: 0,
      successFiles: [],
      articleTags: [],
      forbitUpload: false,
      forbitEdit: false,
      forbitSave: false,
    };
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  mounted() {
    this.$bus.$on("edit-audio", this.initEditAudio);
  },
  methods: {
    switchEdit() {
      if (this.showEditArea == false) {
        this.showEditArea = true;
        this.switchBtnText = "取消上传";
        this.initUserPermission();
      } else {
        this.showEditArea = false;
        this.resetForm("editAudioForm");
      }
    },
    fileListChange(file, fileList) {
      // console.log(fileList)
      let audio_regexp = /^audio\/\w/g;
      if (!audio_regexp.test(file.raw.type)) {
        this.$message({
          message: "请选择音频文件",
          duration: 1500,
          offset: 230,
        });
        return false;
      }
      this.awaitFile = fileList;
    },
    handleRemove(file, fileList) {
      // 删除本地
    },
    exceedLimit(file, fileList) {
      this.$message({
        message: "最多可选择 1 个音频哦",
        duration: 1500,
        offset: 230,
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.reEditing) {
            this.saveOldAudio(this.$refs[formName].model);
          } else {
            let awaitFiles = this.awaitFile;
            if (awaitFiles.length != 0) {
              this.fileCount = awaitFiles.length;
              this.submitUpload();
            } else {
              this.$message({
                message: "请选择音频",
                type: "warning",
                duration: 1500,
                offset: 230,
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    beforeUpload(file) {
      var newFile = new File([file], newFileName(file.name));
      var formData = new FormData();
      formData.append("file", newFile);
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["uploadUrl"],
          method: apiMap["uploadFile"]["method"],
          url: apiMap["uploadFile"]["url"],
          data: formData,
          timeout: 5000,
        })
        .then(function(response) {
          if (response.data.code == 200) {
            $this.successFiles.push(newFile);
            setTimeout(() => {
              let curFile = {
                name: response.data.fileName,
                url: response.data.file,
                size: newFile.size,
              };
              $this.fileList.push(curFile);
            }, 200);
          }

          var myInterval = setInterval(function() {
            if ($this.successFiles.length == 1) {
              clearInterval(myInterval);
              $this.initAudioFile();
            }
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            $this.$alert("文件上传超时", {
              confirmButtonText: "确定",
              showClose: false,
            });
          } else {
            $this.$message({
              message: "文件上传出错",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        });
      return false;
    },
    submitUpload() {
      this.forbitUpload = true;
      this.$refs.upload.submit(); // 自动执行beforeUpload()
    },
    initAudioFile() {
      let uploadFiles = this.fileList;
      if (uploadFiles.length > 0) {
        var fileName = uploadFiles[0].url;
        var fileSize = (uploadFiles[0].size / 1024).toFixed(2);
        this.publishAudio(
          this.$refs["editAudioForm"].model,
          fileName,
          fileSize
        );
      }
    },
    publishAudio(formData, picture, fileSize) {
      //title singer introduction storage
      let _this = this;
      _this.forbitEdit = true;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var paramArray = [
        `token=${loginUser.token}`,
        `title=${formData.audioTitle}`,
        `singer=${formData.audioSinger}`,
        `introduction=${encodeURIComponent(formData.audioContent)}`,
        `image=${picture}`,
        `storage=${fileSize}`,
      ];
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["uploadAudio"]["method"],
          url: apiMap["uploadAudio"]["url"],
          data: paramArray.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.resetForm("editAudioForm");
            _this.newAudioID = response.data.result.data;
            // 是否弹出分享音频窗口
            // _this.shareVisible = true;
            _this.$bus.$emit("reload-audio-list");
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
            this.$refs.upload.clearFiles();
            this.fileCount = 0;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveOldAudio(formData) {
      let _this = this;
      if (_this.oldAudioID == "") {
        return false;
      }
      _this.forbitEdit = true;
      let paramArr = [
        `token=${loginUser.token}`,
        `title=${formData.audioTitle}`,
        `singer=${formData.audioSinger}`,
        `introduction=${encodeURIComponent(formData.audioContent)}`,
        `musicId=${_this.oldAudioID}`,
      ];
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["updateAudio"]["method"],
          url: apiMap["updateAudio"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.resetForm("editAudioForm");
            _this.$message({
              message: "编辑成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-audio-list");
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
      this.forbitSave = false;
      this.forbitUpload = false;
      this.forbitEdit = false;
      this.reEditing = false;
      this.fileList = [];
      this.imageList = [];
      this.successFiles = [];
      this.failFiles = [];
      this.fileCount = 0;
      this.oldAudioID = "";
      if (this.showEditArea) {
        this.switchBtnText = "取消上传";
      } else {
        this.switchBtnText = "上传音频";
      }
      this.saveBtnText = "开始上传";
      this.uploaderTipText = "允许上传 1 个音频文件";
    },
    clearShareForm() {
      this.$refs["shareAudioForm"].resetFields();
      this.shareVisible = false;
    },
    submitShareForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(_this.$refs[formName].model);
          let shareArea = _this.$refs[formName].model.shareArea;
          if (shareArea.length == 1) {
            _this.shareNewAudio(shareArea[0]);
          } else if (shareArea.length == 2) {
            _this.shareNewAudio(shareArea[0]);
            _this.shareNewAudio(shareArea[1]);
          }
          _this.clearShareForm();
        } else {
          return false;
        }
      });
    },
    shareNewAudio(shareArea) {
      let _this = this;
      if (_this.newAudioID == "") {
        return false;
      }
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&musicId=${_this.newAudioID}&shareField=${shareArea}&shareValue=1`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["musicShare"]["method"],
          url: apiMap["musicShare"]["url"],
          data: params,
        })
        .then(function(response) {
          let tips = "";
          switch (shareArea) {
            case "shareFriends":
              tips = "到小区";
              break;
            case "sharePublic":
              tips = "到社区";
              break;
          }
          if (response.data.result.statusCode == 1) {
            let msg = `分享${tips}成功！`;
            _this.$message({
              message: msg,
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-audio-list");
          } else {
            let msg = `分享${tips}失败，稍后再试`;
            _this.$message({
              message: msg,
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initEditAudio(audioID) {
      this.showEditArea = true;
      this.switchBtnText = "取消编辑";
      this.uploaderTipText = "重新编辑音频时，不能选择音频";
      this.saveBtnText = "保存";
      this.forbitUpload = true;
      this.loadAudio = true;
      document.documentElement.scrollTop = 0;
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: audioID,
            modelType: 3,
            self: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.loadAudio = false;
            _this.reEditing = true;
            _this.oldAudioID = response.data.result.data.modelId;
            _this.editAudioForm.audioTitle = htmlFilter(
              response.data.result.data.title
            );
            if (response.data.result.data.introduction != "null") {
              _this.editAudioForm.audioContent = htmlFilter(
                response.data.result.data.introduction
              );
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initUserPermission() {
      if (this.userProfile.musicPermission == 0) {
        this.$alert("抱歉，您目前没有权限上传音频", {
          confirmButtonText: "确定",
          showClose: false,
        });
        this.forbitEdit = true;
      } else {
        var myTempSpace = parseFloat(
          this.userProfile["tempSpaceSizeMbNum"]
        ).toFixed(2);
        var residueSpace = myTempSpace - this.userProfile["tempUsedSpaceMBNum"];
        if (residueSpace < 0) {
          this.$alert("您的短期空间不足，请在手机端续费或购买", {
            confirmButtonText: "确定",
            showClose: false,
          });
          this.forbitEdit = true;
        }
      }
    },
  },
};
</script>
<style scoped>
.edit-body {
  min-height: 80px;
  margin: 15px 0 0;
}
</style>
